import { Component, OnInit } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { ContactList } from '../contactList';
import { Contact } from '../contact.model';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  animations: [
    trigger('navBar', [
      state('beforeCollapsed', style({ })),
      state('afterCollapsedNav', style({
        width: '3%'
      })),
      state('afterCollapsedDashboard', style({
        width: '97%'
      })),
      state('afterCollapsedHidden', style({
        display: 'none'
      })),
      
      transition('beforeCollapsed <=> afterCollapsedNav', [animate('0.8s ease')]),
      transition('beforeCollapsed <=> afterCollapsedDashboard', [animate('0.8s ease')])
    ])
  ]
})
export class DashboardComponent implements OnInit {

  contactItem: Contact = new Contact();
  contactList = ContactList;
  navCollapsed = false;

  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit(): void {
    const headers = {'content-type': 'application/json'};
    this.http.get('http://localhost:8000/api/contact-list', {'headers': headers}).subscribe((response: any)=> {
      this.contactList = response;
    });
  }

  checkContact(i: number){
    // this.router.navigate(['/dashboard/check', {contact: this.contactList[i]}]);
    this.contactItem = this.contactList[i];
    this.router.navigate(['dashboard/check',this.contactItem]);
  }
}
